import altimeterImage from '../../../../../../assets/image/altimeter_comparison.png';
import inSituScatterPlotImage from '../../../../../../assets/image/in_situ_scatter_plot_get_started.png';
import inSituTimeSeriesImage from '../../../../../../assets/image/in_situ_time_series_get_started.png';
import { FeatureFigure } from './FeatureFigure';

export function ValidationSection() {
  return (
    <>
      <h2>Validation</h2>
      <p>
        Assuring the quality of the data is the first step to take. Therefore, validations can be
        freely assessed, prior to any purchase, via detailed comparisons against measurements.
      </p>
      <h3>Alimeter comparison</h3>
      <p>
        An altimeter comparison provides a quick assessment of the accuracy by comparing the local
        model data against satellite altimeter measurements within a radius of 50 km. This service
        is available globally (it is recommended to select a location {'>'}
        30 km from land).
      </p>
      <FeatureFigure
        src={altimeterImage}
        caption="Comparing significant wave height (Hm0) of the North Europe dataset against satellite altimeter measurements within 50 km."
      />
      <h3>In situ Comparison</h3>
      <p>
        In situ comparison validates the model data against measurements from the nearest in situ
        station, shown as time series, scatter and rose plots. If no station is available at the
        selected location, the point can be moved to the closest station, or you can upload your own
        measurements using the provided CSV template.
      </p>
      <FeatureFigure src={inSituTimeSeriesImage} caption="In situ comparison time series." />
      <FeatureFigure src={inSituScatterPlotImage} caption="In situ comparison scatter plot." />
    </>
  );
}
